import type React from 'react';

export interface NotificationUnreadProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const NotificationUnread: React.FC<NotificationUnreadProps> = ({
	width = 20,
	height = 22,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Notifications Unread Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 35 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<rect
			opacity="0.1"
			width="35.7644"
			height="29.3071"
			rx="5"
			fill="currentColor"
		/>
		<path
			d="M17.0771 7.55463C17.3261 7.42703 17.6019 7.36049 17.8817 7.36049C18.1616 7.36049 18.4374 7.42703 18.6864 7.55463L25.1565 10.8683C25.4569 11.0222 25.7068 11.2592 25.8764 11.551L17.8832 15.7587L9.90259 11.5247C10.0721 11.2447 10.3161 11.0174 10.6075 10.8683L17.0771 7.55463ZM9.64708 12.7208L17.606 16.9436C17.6906 16.9885 17.7849 17.012 17.8807 17.0122C17.9765 17.0123 18.0708 16.9891 18.1556 16.9445L26.1164 12.7542V20.1819C26.1164 20.6499 25.9305 21.0987 25.5996 21.4296C25.2687 21.7606 24.8198 21.9465 24.3518 21.9465H11.4117C10.9437 21.9465 10.4948 21.7606 10.1639 21.4296C9.83299 21.0987 9.64708 20.6499 9.64708 20.1819V12.7208ZM19.2224 6.50765C18.8074 6.29515 18.3479 6.18433 17.8817 6.18433C17.4156 6.18433 16.9561 6.29515 16.5411 6.50765L10.0711 9.82128C9.58922 10.068 9.18484 10.443 8.90247 10.9049C8.6201 11.3668 8.47069 11.8976 8.4707 12.439V20.1819C8.4707 20.9619 8.78055 21.7099 9.33209 22.2615C9.88362 22.813 10.6317 23.1228 11.4117 23.1228H24.3518C25.1318 23.1228 25.8799 22.813 26.4314 22.2615C26.9829 21.7099 27.2928 20.9619 27.2928 20.1819V12.439C27.2928 11.8976 27.1434 11.3668 26.861 10.9049C26.5787 10.443 26.1743 10.068 25.6924 9.82128L19.2224 6.50765Z"
			fill="currentColor"
		/>
	</svg>

);

export default NotificationUnread;

